import { useState } from "react";
import SummaryApi from "../common";
import fetchWithAuth from "../common/fetchWithAuth";


const useLedger = () => {
    const [loading, setLoading] = useState(false);


    const addParty = async (partyData) => {
        setLoading(true);
        try {
            const res = await fetchWithAuth(SummaryApi.addParty.url, {
                method: SummaryApi.addParty.method,
                body: JSON.stringify(partyData)
            });
            const data = await res.json();
            if (!res.ok) {
                throw new Error(data.message || 'failed to Add data');
            }
            return data;
        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
        }
    }
    const getAllParties = async () => {
        setLoading(true);
        try {
            const res = await fetchWithAuth(SummaryApi.getAllParties.url, {
                method: SummaryApi.getAllParties.method,
            });
            const partieData = await res.json();
            if (!res.ok) {
                throw new Error(partieData.message || 'failed to fetch data');
            }
            console.log(partieData.data);
            return partieData.data;
        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
        }
    }

    const getPartyById = async (partyId) => {
        setLoading(true);
        try {
            const response = await fetchWithAuth(SummaryApi.getPartiesById.url(partyId), {
                method: SummaryApi.getPartiesById.method
            });

            const partyData = await response.json();

            if (!response.ok) {
                throw new Error(partyData.message || 'Failed to fetch data');
            }

            return partyData;

        } catch (err) {
            throw new Error('error fetching Party Details');
        } finally {
            setLoading(false);
        }
    }

    //bills and payment related Api call
    const addBill = async (payLoad) => {
        setLoading(true);
        try {
            const response = await fetchWithAuth(SummaryApi.addBill.url, {
                method: SummaryApi.addBill.method,
                body: JSON.stringify(payLoad)
            })
            const billData = await response.json();

            if (!response.ok) {
                throw new Error(billData.message || 'failed to add bill');
            }
            console.log(billData);
            return billData;
        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
        }
    }

    const getBillsById = async (partyId) => {
        setLoading(true);
        try {
            const response = await fetchWithAuth(SummaryApi.getPartyBillsById.url(partyId), {
                method: SummaryApi.getPartyBillsById.method
            });

            const billsData = await response.json();
            console.log(billsData);
            if (!response.ok) {
                throw new Error(billsData.message || 'Failed to fetch data');
            }

            return billsData;

        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
        }
    }

    const addPayment = async (payLoad) => {
        try {
            const response = await fetchWithAuth(SummaryApi.addPayment.url, {
                method: SummaryApi.addPayment.method,
                body: JSON.stringify(payLoad)
            })
            const paymentData = await response.json();

            if (!response.ok) {
                throw new Error(paymentData.message || 'failed add Payment');
            }
            console.log(paymentData);
            return paymentData;
        } catch (err) {
            throw err;
        }
    }

    const addPartyPayment = async (payLoad) => {
        try {
            const response = await fetchWithAuth(SummaryApi.addPartyPayment.url, {
                method: SummaryApi.addPartyPayment.method,
                body: JSON.stringify(payLoad)
            })
            const paymentData = await response.json();

            if (!response.ok) {
                throw new Error(paymentData.message || 'failed add Party Payment');
            }
            console.log(paymentData);
            return paymentData;
        } catch (err) {
            throw err;
        }
    }

    const getPaymentsByBillId = async (billId) => {
        try {
            const response = await fetchWithAuth(SummaryApi.getPaymentsByBillId.url(billId), {
                method: SummaryApi.getPaymentsByBillId.method
            });
            const paymentData = await response.json();
            if (!response.ok) {
                throw new Error(paymentData.message || 'failed to fetch payment data');
            }
            return paymentData;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
    const cancelBill = async (billId) => {
        try {
            const response = await fetchWithAuth(SummaryApi.cancelBill.url(billId), {
                method: SummaryApi.cancelBill.method
            });
            const cancelBillData = await response.json();
            if (!response.ok) {
                throw new Error(cancelBillData.message || 'failed to bill cancel');
            }
            console.log(cancelBillData);
            return cancelBillData;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const updateBillStatus = async (billId, status) => {
        try {
            const response = await fetchWithAuth(SummaryApi.updateBillStatus.url, {
                method: SummaryApi.updateBillStatus.method,
                body: JSON.stringify({ billId, status })
            })
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'failed to update bill status');
            }
            return data;
        } catch (err) {
            throw err;
        }
    }

    return {
        loading,
        addParty,
        getAllParties,
        getPartyById,
        addBill,
        getBillsById,
        addPayment,
        addPartyPayment,
        getPaymentsByBillId,
        cancelBill,
        updateBillStatus
    }
}

export default useLedger;